"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStaffEndpoints = createStaffEndpoints;
/**
 * PERSONEL KİMLİĞİ VE PANEL İŞ UÇLARI — `/panel/*` (panel kimliği ayrımı).
 *
 * YALNIZ `apps/admin` ÇAĞIRIR. `apps/web` ve `apps/mobile` bu alan grubuna
 * hiç dokunmaz; ölçüm `admin-panel-endpoint.guard.spec.ts` içindedir (ürün
 * uygulamalarında `staff.` çağrısı = 0, panelde `/panel` dışına giden kimlikli
 * çağrı = 0).
 *
 * Erişim jetonu BELLEKTE, yenileme jetonu `wb_staff_refresh` HttpOnly
 * çerezinde ve path'i `/api/panel/auth` — yani ürünün `wb_refresh` çerezinden
 * ayrıdır ve tarayıcı onu ürün uçlarına HİÇ göndermez.
 */
function createStaffEndpoints(client) {
    return {
        staff: {
            // --- Kimlik ---------------------------------------------------------
            /** Giriş 1. adım (e-posta + şifre) — OTURUM AÇMAZ, kod gönderir. */
            login: (input) => client.call('/panel/auth/login', 'post', { body: input }),
            /** Giriş 2. adım (kod) — oturumu açan tek uç. */
            verify: (input) => client.call('/panel/auth/verify', 'post', { body: input }),
            /** İlk kurulum: davet jetonu + şifre. Panelde "şifremi unuttum" YOKTUR. */
            setup: (input) => client.call('/panel/auth/setup', 'post', { body: input }),
            refresh: () => client.call('/panel/auth/refresh', 'post', { body: {} }),
            logout: () => client.call('/panel/auth/logout', 'post', {}),
            me: () => client.call('/panel/auth/me', 'get', {}),
            changePassword: (input) => client.call('/panel/auth/password', 'post', { body: input }),
            sessions: () => client.call('/panel/auth/sessions', 'get', {}),
            revokeSession: (sessionId) => client.call('/panel/auth/sessions/{sessionId}', 'delete', { path: { sessionId } }),
            revokeAllSessions: () => client.call('/panel/auth/sessions/revoke-all', 'post', {}),
            // --- Personel hesapları (yalnız admin) -------------------------------
            accounts: () => client.call('/panel/staff', 'get', {}),
            createAccount: (input) => client.call('/panel/staff', 'post', { body: input }),
            reinvite: (staffAccountId) => client.call('/panel/staff/{staffAccountId}/invite', 'post', { path: { staffAccountId } }),
            cancelInvitation: (staffAccountId) => client.call('/panel/staff/{staffAccountId}/invite', 'delete', { path: { staffAccountId } }),
            suspendAccount: (staffAccountId) => client.call('/panel/staff/{staffAccountId}/suspend', 'post', { path: { staffAccountId } }),
            unsuspendAccount: (staffAccountId) => client.call('/panel/staff/{staffAccountId}/unsuspend', 'post', {
                path: { staffAccountId },
            }),
        },
    };
}
//# sourceMappingURL=staff.js.map